import styled from "styled-components";

export const OnePageHeader = styled.div`
  display: flex;
  height: 315px;
  justify-content: center;
  align-items: center;

  img {
    width: 330px;
  }
`;

export const SrhJumbotron = styled.div`
  font-family: "Open Sans Condensed" !important;
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.white};
  padding: 40px 10px;
  margin-bottom: 35px;
  text-align: center;
  h1 {
    font-size: 52px;
    margin-bottom: 0;
  }
  h2 {
    font-size: 42px;
    margin-top: 14px;
    margin-bottom: 0;
  }
  h3 {
    font-size: 30px;
    margin-top: 14px;
    margin-bottom: 0;
  }
  h4 {
    color: ${props => props.theme.primaryXLight};
    font-size: 28px;
    margin-top: 7px;
    margin-bottom: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  div {
    font-family: "Open Sans Condensed" !important;
  }

  .smaller-x1 {
    font-size: 35px;
  }

  .smaller-x2 {
    font-size: 30px;
  }

  .smaller-x3 {
    font-size: 26px;
  }

  .smaller-x4 {
    font-size: 24px;
  }

  .smaller-x5 {
    font-size: 22px;
  }

  .truncate {
    font-size: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const WatermarkedDiv = styled.div`
  margin: 0 50px;
  h4 {
    color: ${props => props.theme.primary};
    font-weight: bold;
    font-size: 22px;
    @media print {
      margin-bottom: 11px;
    }
  }
  p {
    font-size: 17px;
    color: #000;
    line-height: 23px;

    @media print {
      margin-bottom: 14px;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  div {
    font-family: "Open Sans Condensed" !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/TitlePage/style.js